import { Module } from '../Module';

Module.instance().directive('tbMousedownOutside', <any[]>[
  '$parse',
  ($parse: ng.IParseService) => {
    return {
      link: (scope: ng.IScope, element: JQuery, attr: ng.IAttributes) => {
        const eventNamespace = '.tbMousedownOutside' + scope.$id;
        const downOutsideFn = $parse(attr['tbMousedownOutside']);
        const doc = angular.element(document);
        const mousedownEvents = 'mousedown' + eventNamespace + ' touchstart' + eventNamespace;

        doc.on(mousedownEvents, (downEvent: JQuery.TriggeredEvent) => {
          const target = $(downEvent.target);
          if (target.closest(element).length === 0) {
            scope.$apply(() => {
              downOutsideFn(scope, { $event: downEvent });
            });
          }
        });
        element.on('$destroy', () => {
          doc.off(eventNamespace);
        });
      }
    };
  }
]);
